@if (!renderStatic) {
<lib-gung-input-multi-select
  [label]="suppressLabel ? undefined : label"
  [optionsList]="metaOptionsMulti"
  (selectedValues)="setSelectedValues($event)"
  [showId]="showId"
  [previewEmpty]="previewEmpty"
  [dropdownCustomClass]="dropdownCustomClass"
  [previewField]="previewField"
  [disabled]="disabled"/>
} @else {
  <!-- <lib-gung-text-input
      [label]="suppressLabel ? undefined : label"
      [suppressLabel]="suppressLabel"
      [renderStatic]="renderStatic"
      [ngModel]="readOptionFn(metaOptionsMulti)"/> -->
  {{readOptionFn(metaOptionsMulti)}}
}
